const BASE = "/api/admin";
import { anyWorkspaceToken, clearWorkspaceSession } from "./workspaces";

function getToken(): string | null {
  return anyWorkspaceToken();
}

function authHeaders(): Record<string, string> {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function adminApi<T = unknown>(
  path: string,
  opts: RequestInit = {},
): Promise<{ success: boolean; data?: T; error?: { key?: string; message: string }; pagination?: any }> {
  const res = await fetch(`${BASE}${path}`, {
    ...opts,
    headers: {
      "Content-Type": "application/json",
      ...authHeaders(),
      ...opts.headers,
    },
  });
  if (res.status === 401) {
    clearWorkspaceSession();
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }
  return res.json();
}

export function adminGet<T = unknown>(path: string) {
  return adminApi<T>(path);
}

export function adminPatch<T = unknown>(path: string, body: unknown) {
  return adminApi<T>(path, { method: "PATCH", body: JSON.stringify(body) });
}

export function adminPost<T = unknown>(path: string, body?: unknown) {
  return adminApi<T>(path, { method: "POST", body: body ? JSON.stringify(body) : undefined });
}

export function adminDelete<T = unknown>(path: string) {
  return adminApi<T>(path, { method: "DELETE" });
}
